import Vue from 'vue'
import Vuex from 'vuex'
import ContentModule from './vuex/module/content'
import AdminModule from './vuex/module/admin'
import NotificationModule from './vuex/module/notification'
import BannersModule from './vuex/module/banners'
import ProductModule from './vuex/module/portal/product'
import VarietyModule from './vuex/module/portal/variety'
import WorkflowModule from './vuex/module/portal/workflow'
import KnowledgeModule from './vuex/module/portal/knowledge'
import TopicModule from './vuex/module/portal/topic'
import ConsultingTopicModule from './vuex/module/farmerspace/consulting-topic'
import ConsultingBeneficiaryModule from './vuex/module/farmerspace/consulting-beneficiary'
import ConsultingCaseModule from './vuex/module/farmerspace/consulting-case'
import RawDataModule from './vuex/module/portal/rawdata'
import PartsModule from './vuex/module/portal/parts'
import PropertiesModule from './vuex/module/portal/properties'
import PlaceModule from './vuex/module/portal/place'
import FbLoginModule from './vuex/module/fb_login'
import GreetingModule from './vuex/module/farmerspace/greeting'
import TypesModule from './vuex/module/portal/types'
import WordingTypeModule from './vuex/module/farmerspace/wording-type'
import WordingModule from './vuex/module/farmerspace/wording'
import PagesModule from './vuex/module/portal/pages'
import ShopEditionModule from './vuex/module/farmerspace/shop-edition'
import ShopEditionProductModule from './vuex/module/farmerspace/shop-edition-product'
import ShopEditionProductItemModule from './vuex/module/farmerspace/shop-edition-product-item'
import ShopEditionProductItemPriceModule from './vuex/module/farmerspace/shop-edition-product-item-price'
import ShopOrderListModule from './vuex/module/farmerspace/shop-order-list'

Vue.use(Vuex)

const modules = {
  // Admin
  ConsultingTopic: ConsultingTopicModule,
  ConsultingBeneficiary: ConsultingBeneficiaryModule,
  ConsultingCase: ConsultingCaseModule,
  Greeting: GreetingModule,
  WordingType: WordingTypeModule,
  Wording: WordingModule,
  Pages: PagesModule,
  ShopEdition: ShopEditionModule,
  ShopEditionProduct: ShopEditionProductModule,
  ShopEditionProductItem: ShopEditionProductItemModule,
  ShopEditionProductItemPrice: ShopEditionProductItemPriceModule,
  ShopOrderList: ShopOrderListModule,
  // Users
  Content: ContentModule,
  Admin: AdminModule,
  Notification: NotificationModule,
  Banners: BannersModule,
  Product: ProductModule,
  Variety: VarietyModule,
  Workflow: WorkflowModule,
  Knowledge: KnowledgeModule,
  Topic: TopicModule,
  RawData: RawDataModule,
  Parts: PartsModule,
  Properties: PropertiesModule,
  Place: PlaceModule,
  FbLogin: FbLoginModule,
  Types: TypesModule
}

export default new Vuex.Store({
  modules,
  strict: false
})
